"use strict";

define('libs/pendo.initializer',['require','exports','module','underscore'],function (require, exports, module) {
  var _ = require('underscore');
  var isNil = function isNil(o) {
    return _.isUndefined(o) || _.isNull(o);
  };
  var addPropIfValueExists = function addPropIfValueExists(pendoObject, propName, value) {
    if (!isNil(value)) {
      pendoObject[propName] = value;
    } else {
      console.warn('Property "' + propName + '" will not be added to Pendo metadata because the value it would have is `' + value + '`.');
    }
  };
  var safeGetPersonEmail = function safeGetPersonEmail(user) {
    var email = null;
    try {
      email = user.getPersonEmail();
    } catch (e) {
      console.error('Unable to retrieve email address for Pendo metadata.\n', e);
    }
    return email;
  };
  var safeGetPersonRoles = function safeGetPersonRoles(user) {
    var roles = null;
    try {
      roles = user.getPerson().getRoles();
    } catch (e) {
      console.error('Unable to retrieve user roles for Pendo metadata.\n', e);
    }
    return roles;
  };
  var safeGetTenantHostname = function safeGetTenantHostname(user) {
    var hostname = null;
    try {
      hostname = user.getAssociatedTenant().hostname;
    } catch (e) {
      console.error('Unable to retrieve tenant hostname for Pendo metadata.\n', e);
    }
    return hostname;
  };
  module.exports = {
    initialize: function initialize(user) {
      var pendoVisitor = {
        id: user.getPersonId()
      };
      addPropIfValueExists(pendoVisitor, 'email', safeGetPersonEmail(user));
      addPropIfValueExists(pendoVisitor, 'roles', safeGetPersonRoles(user));
      var pendoAccount = {
        product: 'IRB'
      };
      addPropIfValueExists(pendoAccount, 'id', safeGetTenantHostname(user));
      try {
        pendo.initialize({
          visitor: pendoVisitor,
          account: pendoAccount
        });
      } catch (e) {
        console.error('Error initializing Pendo. Ensure Pendo is properly installed.\n', e);
      }
    }
  };
});

